import React from 'react';
import cn from 'classnames';
import styles from './Modal.module.scss';

import ReactModal from 'react-modal';

export default function Modal({className, onClose, shouldCloseOnOverlayClick = true, children}) {
    return (
        <ReactModal
            isOpen
            overlayClassName={styles.overlay}
            className={cn(className, styles.modal)}
            contentLabel=''
            ariaHideApp={false}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            onRequestClose={onClose}
        >
            {children}
        </ReactModal>
    );
}
